export default "__VITE_ASSET__3nvrNrZ___"